<template>
    <div>
        <div class="tabs is-small">
            <ul>
                <router-link
                    :to="{ name: 'client-settings-view-analytics' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Analytics</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-auth' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Auth</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-banners' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Banners</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-bk' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>BK</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-bot' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Bot</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-general' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>General</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-language' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Language</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-legal' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Legal</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-menu' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Menu</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-mobile' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Mobile</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-payments' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Payments</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-player-activity' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Player activity</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-profile' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Profile</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-routing' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Routing</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-style' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Style</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-view-sweepstakes' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Sweepstakes</a>
                </router-link>
            </ul>
        </div>

        <router-view />
    </div>
</template>
<script>
export default {
    name: 'client-settings-view'
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/index.vue